import React from "react";
import { H1 } from "ui-components";

const Ping = () => <H1>Hello World</H1>;
export default Ping;
